import axios from 'axios';
import { Store } from 'vuex';
import router from './../router';
import LocalStorageService from './storage/localStorageService';
import { getAPIEndpoint } from '../helpers';
// import LocalStorageService from './storage/localStorageService';

const localStorageService = LocalStorageService.getService();

const axiosInstance = axios.create({
  timeout: 10000
});

axiosInstance.interceptors.request.use(
  function (config) {
    const token = localStorage.getItem('cafe_jwt') || '';

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  function (err) {
    return Promise.reject(err);
  }
);

// axiosInstance.interceptors.response.use(
//   response => {
//     return response;
//   },
//   function(error) {
//     const originalRequest = error.config;

//     if (
//       error.response.status === 401 &&
//       originalRequest.url === `${getAPIEndpoint()}/auth/refresh-token`
//     ) {
//       localStorage.removeItem('cafe_jwt');
//       localStorage.removeItem('refreshToken');
//       router.push('/login');

//       return Promise.reject(error);
//     }

//     if (error.response.status === 401 && !originalRequest._retry) {
//       originalRequest._retry = true;
//       const refreshToken = localStorageService.getRefreshToken();
//       return axios
//         .post(`${getAPIEndpoint()}/auth/refresh-token`, {
//           refreshToken: refreshToken
//         })
//         .then(res => {
//           if (res.status === 201) {
//             localStorageService.setToken(res.data);
//             axios.defaults.headers.common['Authorization'] =
//               'Bearer ' + localStorageService.getAccessToken();
//             return axios(originalRequest);
//           }
//         });
//     }
//     return Promise.reject(error);
//   }
// );

export default axiosInstance;
